import { render, staticRenderFns } from "./ApplicantsMns.vue?vue&type=template&id=2be6e97a&"
import script from "./ApplicantsMns.vue?vue&type=script&lang=js&"
export * from "./ApplicantsMns.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantsMns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports